export const DELIVERY_IN_HOUSE = "IN_HOUSE";
export const DELIVERY_THIRD_PARTY = "THIRD_PARTY";
export const DELIVERY_FOOD_AGGREGATOR = "FOOD_AGGREGATOR";
export const DELIVERY_JOB_CREATION_FAILED = "DELIVERY_JOB_CREATION_FAILED";
export const SELF_MANAGED_DELIVERY_PARTNER = "SELF_MANAGED_DELIVERY_PARTNER";
export const SELF_MANAGED_DELIVERY_PARTNER_NAME = "Manual";
export const DASH = "-";

export const STORAGE_KEY_IS_IN_SELF_MANAGED_MODE = "isInSelfManagedDeliveryMode";
export const STORAGE_KEY_IS_USING_RULE_BASED_CONFIG = "isUsingRuleBasedConfiguration";
export const STORAGE_KEY_COMPLETED_TAB_ROWS_PER_PAGE = "completedTabRowsPerPage";


export const KEY_PARTNER_SELECTION = "partnerSelection";
export const KEY_AD_USER = "adUser";
export const KEY_ADMIN_AUTH_TOKEN = "adminAuthToken";
export const KEY_HAS_ONGOING_ADMIN_LOGIN = "hasOngoingAdminLogin";